import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sales",
  "use": "sales-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"sales\"><path d=\"M310.11 303.61a6.5 6.5 0 0 1-6.5 6.5H96.39a6.5 6.5 0 0 1-6.5-6.5V96.39a6.5 6.5 0 0 1 13 0v200.72h200.72a6.5 6.5 0 0 1 6.5 6.5zm-166.53-55.23a9.27 9.27 0 0 0 9.23-10.38l40-49.18a9.24 9.24 0 0 0 1.28-.21l37.12 23.51a9.3 9.3 0 1 0 18.06-4.36l41.62-70.83a9.32 9.32 0 1 0-11.21-6.58l-41.58 70.76-37.1-23.46a9.3 9.3 0 0 0-18.33 3l-40 49.19a9.3 9.3 0 0 0 .85 18.56z\" fill=\"#3c4859\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol